import { render, staticRenderFns } from "./KycSolicitanteTemplate.vue?vue&type=template&id=f43dd9f0&scoped=true"
import script from "./KycSolicitanteTemplate.vue?vue&type=script&lang=js"
export * from "./KycSolicitanteTemplate.vue?vue&type=script&lang=js"
import style0 from "./KycSolicitanteTemplate.vue?vue&type=style&index=0&id=f43dd9f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43dd9f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f43dd9f0')) {
      api.createRecord('f43dd9f0', component.options)
    } else {
      api.reload('f43dd9f0', component.options)
    }
    module.hot.accept("./KycSolicitanteTemplate.vue?vue&type=template&id=f43dd9f0&scoped=true", function () {
      api.rerender('f43dd9f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/KycSolicitanteTemplate.vue"
export default component.exports